module.exports = __webpack_public_path__ + "static/media/Left Lateral Z1.6e81b9ec.png";